import React, { FC } from 'react'
import { FlexContainer, elFlex1, elHFull, BodyText, TextArea, InputGroup, InputWrap } from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'
import { cx } from '@linaria/core'
import { useDialogChangedRequest } from './use-dialog-changed-request'
import { ChangedRequestActionFooter } from './changed-request-action-footer'
import { DialogWrapper } from '@reapitform/common-ui'

export interface IDialogChangedRequest {
  className?: string
  isModalOpen: boolean
  handlerModalClose: () => void
}

export const DialogChangedRequest: FC<IDialogChangedRequest> = ({ className, handlerModalClose, isModalOpen }) => {
  const { register, isValid, handleSubmitChangeRequest, isSubmitLoading } = useDialogChangedRequest({
    onSuccess: () => handlerModalClose(),
  })

  return (
    <ErrorBoundary>
      <DialogWrapper
        hasFullScreen
        hasCloseButton
        {...{ isModalOpen, className, handlerModalClose, title: 'Request a change' }}
        footer={
          <ChangedRequestActionFooter {...{ handlerModalClose, handleSubmitChangeRequest, isValid, isSubmitLoading }} />
        }
      >
        <FlexContainer hasMaxWidth isFlexColumn className={cx(elHFull, elFlex1)}>
          <BodyText>
            Please provide exact details of the change below. Your request will be submitted at the end of the
            Agreement.
          </BodyText>
          <InputWrap>
            <InputGroup>
              <TextArea {...register('changesRequested')}></TextArea>
            </InputGroup>
          </InputWrap>
        </FlexContainer>
      </DialogWrapper>
    </ErrorBoundary>
  )
}
